import SuggestionItem from './SuggestionItem';
import { IMAGE_URL } from 'shared/constants';
import defaultImage from 'assets/images/search_icon.png';
import qs from 'qs';

const SearchSuggestions = ({
  visible,
  suggestions,
  searchedText,
  onSuggestionClick,
}) => {
  const { categories } = suggestions;

  return (
    <ul className={`global_search ${visible ? 'show_search_dropdown' : ''}`}>
      {/*<li>
        <a
          href="/"
          onClick={(e) => e.preventDefault()}
          className="global_search_list"
        >
          <div className="searchimg">
            <img
              src={require('assets/images/404/shoe.png').default}
              alt="shoe"
            />
          </div>
          <div className="searchtext">
            <span>sh</span>oes<h6>in Men's Sports Shoes</h6>
          </div>
        </a>
      </li>
      <li>
        <a
          href="/"
          onClick={(e) => e.preventDefault()}
          className="global_search_list"
        >
          <div className="searchimg">
            <img
              src={require('assets/images/404/shoe.png').default}
              alt="shoe"
            />
          </div>
          <div className="searchtext">
            <span>sh</span>oes<h6>in Men's Formal Shoes</h6>
          </div>
        </a>
      </li>
      <li>
        <a
          href="/"
          onClick={(e) => e.preventDefault()}
          className="global_search_list"
        >
          <div className="searchimg">
            <img
              src={require('assets/images/404/shirt_sc.jpg').default}
              alt="shoe"
            />
          </div>
          <div className="searchtext">
            <span>sh</span>irts<h6>in Formal Shirts</h6>
          </div>
        </a>
      </li>
      <li>
        <a
          href="/"
          onClick={(e) => e.preventDefault()}
          className="global_search_list"
        >
          <div className="searchimg search_img_sm">
            <img
              src={require('assets/images/search_icon.png').default}
              alt="search"
              className="iconsearch_sm"
            />
          </div>
          <div className="searchtext">showpieces</div>
        </a>
      </li>
      <li>
        <a
          href="/"
          onClick={(e) => e.preventDefault()}
          className="global_search_list"
        >
          <div className="searchimg search_img_sm">
            <img
              src={require('assets/images/search_icon.png').default}
              alt="search"
              className="iconsearch_sm"
            />
          </div>
          <div className="searchtext">bags</div>
        </a>
      </li>*/}
      {!!categories &&
        !!categories.length &&
        categories.map((category) => {
          const { title, categoryImage, slug } = category;
          const imagePath = categoryImage
            ? `${IMAGE_URL}/${categoryImage.path}`
            : defaultImage;
          const query = qs.stringify({ category: slug, term: searchedText });

          return (
            <SuggestionItem
              key={slug}
              image={imagePath}
              text={searchedText}
              extraText={title}
              onItemClick={onSuggestionClick}
              query={query}
            />
          );
        })}
    </ul>
  );
};

export default SearchSuggestions;
